import {createConfig, http} from 'wagmi'
import {mainnet, } from 'wagmi/chains'
import {getDefaultConfig} from "connectkit";

// export const config = createConfig({
//   chains: [mainnet, sepolia],
//   transports: {
//     [mainnet.id]: http(),
//     [sepolia.id]: http(),
//   },
//   connectors: [
//     injected(),
//     walletConnect({ projectId:'7c352477d6bf63d3b63598fbabfdbe3f' }),
//     metaMask(),
//     safe(),
//   ],
// })
export const config = createConfig(
  getDefaultConfig({
    // Your dApps chains
    chains: [mainnet],
    transports: {
      // RPC URL for each chain
      [mainnet.id]: http(mainnet.rpcUrls.default.http[0]), // or your own RPC url
    },

    // Required API Keys
    walletConnectProjectId: '7c352477d6bf63d3b63598fbabfdbe3f',

    // Required App Info
    appName: "Carrot and stick",

    // Optional App Info
    appDescription: "Carrot and stick",
    enableFamily: false
  }),
);
